<template>
  <div class="article-search overlay--dropdown" role="search">
    <OverlayContainer class="article-search__components" :event-bus="eventBus">
      <div class="textsearch" search-request="">
        <label for="textSearch_input" class="sr-only">
          Søg bl.a. på mærke, model, forfatter
        </label>
        <div class="input input--search">
          <input
            title="Søg bl.a. på mærke, model, forfatter"
            id="textSearch_input"
            type="text"
            placeholder="Søg bl.a. på mærke, model, forfatter..."
            class="input--search"
            v-model="searchString"
            @keyup.enter="handleSearch"
            @focus="closeOverlay"
            ref="textSearchInput"
          />
          <ClearInput
            :value="searchString"
            :event-bus="eventBus"
            :search-icon="true"
          />
        </div>
      </div>
      <component
        v-for="(component, index) in ui.components"
        v-bind="component.props"
        :key="index"
        :is="component.type"
        :id="component.id"
        :event-bus="eventBus"
        :product-type-id="searchRequest[0]"
        :search-request="searchRequest"
        :clear-search-activated="clearSearchActivated"
        :search-types="component.searchTypes"
      ></component>
      <button class="button button--highlight" @click="handleSearch">
        søg
      </button>
    </OverlayContainer>

    <teleport to="#articleSearchResultTeleport">
      <div
        class="article-search__results"
        v-if="searchResult.length > 0 || searchHeader"
      >
        <div class="article-search__header-container" v-if="searchHeader">
          <p class="article-search__header" v-if="searchHeader">
            {{ searchHeader }}
          </p>
          <p class="article-search__section-header">{{ sectionHeader }}</p>
        </div>
        <div class="article-search__result-list" v-if="searchResult">
          <ArticleItem
            v-for="result in searchResult"
            :key="result.imageUrl"
            v-bind="{ ...result }"
          ></ArticleItem>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import { app } from '@/main'
import { nextTick } from 'vue'

import { LogSearchArticles } from '@/events'

import Overlay from '@shared/Overlay/Overlay.vue'
import OverlayProductType from '@shared/OverlayProductType/OverlayProductType.vue'
import OverlayContainer from '@shared/Overlay/OverlayContainer.vue'
import OverlayEventHandlerMixin from '@shared/Overlay/overlay-event-handler-mixin.vue'
import ArticleItem from '@components/ArticleItem/ArticleItem.vue'
import ClearInput from '@shared/ClearInput/ClearInput.vue'

import SearchComponentsMixin from '@search/search-components-mixin.vue'
import SearchMixin from '@components/Search/search-mixin.vue'

import ClearSearch from '@search/ClearSearch/ClearSearch.vue'

export default {
  mixins: [SearchComponentsMixin, OverlayEventHandlerMixin, SearchMixin],
  props: {
    uiProp: { default: null, type: Object },
  },
  data() {
    return {
      searchResult: [],
      searchHeader: '',
      sectionHeader: '',
      searchString: '',
      clearSearchActivated: false,
      countAds: false,
    }
  },
  components: {
    OverlayContainer,
    Overlay,
    OverlayProductType,
    ClearSearch,
    ArticleItem,
    ClearInput,
  },
  created() {
    this.ui = this.uiProp

    if (this.eventBus == null) return

    this.eventBus.on('clear-input-string', this.clearSearchString)
  },
  mounted() {
    this.getFromState()
  },
  methods: {
    saveInState() {
      window.history.replaceState(
        JSON.parse(
          JSON.stringify({
            searchResult: this.searchResult,
            searchHeader: this.searchHeader,
            searchString: this.searchString,
          })
        ),
        '',
        null
      )
    },
    getFromState() {
      if (window.history.state === null) return

      const searchHeader = window.history.state.searchHeader
      const searchResult = window.history.state.searchResult
      const searchString = window.history.state.searchString

      nextTick(() => {
        this.searchHeader = searchHeader
        this.searchResult = searchResult
        this.searchString = searchString
      })
    },
    getSearchRequestObject() {
      const searchRequestObj = {}
      searchRequestObj.MakeIdList = []
      searchRequestObj.ArticleTypeIdList = []
      searchRequestObj.SearchString = this.searchString

      this.searchRequest.forEach(item => {
        if (item.type === 'MakeId') {
          searchRequestObj.MakeIdList.push(item.value)
        } else if (item.type === 'ArticleTypeId') {
          searchRequestObj.ArticleTypeIdList.push(item.value)
        }
      })

      return searchRequestObj
    },
    closeOverlay() {
      if (app.history.getStackSize != 0) {
        app.history.pop()
      }
    },
    clearSearchString() {
      this.searchString = ''

      this.$refs.textSearchInput.focus()
    },
    handleSearch() {
      this.closeOverlay()

      app.axios
        .post('/Api/Article/Search', this.getSearchRequestObject())
        .then(resp => {
          this.searchResult = resp.data.articleList
          this.searchHeader = resp.data.headerText
          this.sectionHeader = resp.data.sectionHeader
          if (resp.data.subText) {
            this.searchHeader += ' - ' + resp.data.subText
          }
          LogSearchArticles()

          nextTick(() => {
            this.saveInState()
          })
        })
    },
    prepareSearchRequest() {
      const copySearchRequest = JSON.parse(JSON.stringify(this.searchRequest)) // figure out a better / more correct way to copy a data element (Vue.util.extend is a shallow copy and won't help here)

      copySearchRequest.forEach(item => {
        const requestItem = item

        if (requestItem.searchValue !== undefined) {
          requestItem.type = requestItem.value
          requestItem.value = requestItem.searchValue

          requestItem.searchValue = undefined
        }
      })

      return copySearchRequest
    },
  },
}
</script>

<style lang="scss">
@use 'ArticleSearch.scss';
</style>
